import { useEffect, useState } from "react";
import BimerAnimatedBackground from "./BimerAnimatedBackground";

const ControllerBimerAnimatedBackground = ({ triggerQuestionAnimation }) => {
	const [clapTriggered, setClapTriggered] = useState(false);
	const [newFloorTriggered, setNewFloorTriggered] = useState(false);
	const [roofFloorTriggered, setRoofFloorTriggered] = useState(false);

	// Extract values to avoid unnecessary re-renders
	const currentIndex = triggerQuestionAnimation?.currentQuestionIndex;
	const totalQuestions = triggerQuestionAnimation?.totalQuestions;

	useEffect(() => {
		if (currentIndex !== undefined && totalQuestions !== undefined) {
			if (currentIndex < totalQuestions - 1) {
				triggerNewFloor();
				triggerClap();
			} else if (currentIndex >= totalQuestions - 1) {
				triggerRoofFloor();
				triggerClap();
			}
		}
	}, [currentIndex, totalQuestions]);

	const triggerClap = () => {
		setClapTriggered(true);
		setTimeout(() => setClapTriggered(false), 500);
	};

	const triggerNewFloor = () => {
		setNewFloorTriggered(true);
		setTimeout(() => setNewFloorTriggered(false), 500);
	};

	const triggerRoofFloor = () => {
		setRoofFloorTriggered(true);
		setTimeout(() => setRoofFloorTriggered(false), 500);
	};

	return (
		<BimerAnimatedBackground
			clapTriggered={clapTriggered}
			newFloorTriggered={newFloorTriggered}
			roofFloorTriggered={roofFloorTriggered}
			triggerClap={triggerClap}
			triggerNewFloor={triggerNewFloor}
			triggerRoofFloor={triggerRoofFloor}
		/>
	);
};

export default ControllerBimerAnimatedBackground;
